import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { isNewCRM } from 'config';
import { LangSwitcher } from 'components/LangSwitcher/LangSwitcher';
import cn from 'classnames';
import './FormHeader.scss';

type FormHeaderProps = {
  title: string | ReactNode;
  backUrl?: string;
};
export const FormHeader = ({ title, backUrl }: FormHeaderProps) => {
  const IS_NEW_CRM = isNewCRM();

  return (
    <div
      className={cn(
        'form-header _flex _flex-a-c _pos-r',
        IS_NEW_CRM ? '_flex-j-c _m-b-30' : '_flex-j-b _m-b-50',
      )}
    >
      {backUrl ? (
        <Link
          to={backUrl}
          className="form-header-link _pos-a _flex _flex-col _flex-xy-c"
          title="back"
          style={{ left: IS_NEW_CRM ? '0px' : '-30px' }}
        >
          <i className="fi fi-rr-angle-small-left _fz-24" />
        </Link>
      ) : null}
      <div className={cn('form-header-title _fw-600', IS_NEW_CRM ? '_fz-24 _text-c' : '_fz-30')}>
        {title}
      </div>
      {!IS_NEW_CRM ? <LangSwitcher closeOnSelect={true} /> : null}
    </div>
  );
};
